<template>
  <div class="offers-view">
    <!-- Toast success - powielenie oferty -->
    <div v-if="showDuplicateToast" class="success-toast">
      ✓ Załadowana powielona oferta dla: {{ duplicatedContractor }}
    </div>

    <!-- HEADER -->
    <div class="page-header">
      <div class="header-left">
        <router-link to="/offers-archive">
          <button class="btn btn-secondary">
            ← Archiwum ofert
          </button>
        </router-link>
      </div>
      <div class="header-center">
        <h3 class="page-title">📄 Nowa oferta</h3>
        <span class="offer-number-badge">{{ offerNumber }}</span>
      </div>
      <div class="header-right"></div>
    </div>

    <!-- FORM -->
    <div class="form-container">
      <!-- Sekcja nagłówków -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📝</span>
          Nagłówki oferty
        </h5>
        
        

        <div class="form-group">
          <label class="form-label">Nagłówek oferty</label>
          <textarea
            class="form-textarea"
            rows="3"
            placeholder="Nagłówek oferty"
            v-model="header"
          ></textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Nagłówek tabeli</label>
          <input
            class="form-input"
            type="text"
            placeholder="Nagłówek tabeli"
            v-model="offerHeader"
          />
        </div>

        <div class="form-group">
          <label class="form-label">Szczegóły oferty</label>
          <textarea
            class="form-textarea"
            rows="4"
            placeholder="Szczegóły oferty"
            v-model="subheader"
          ></textarea>
        </div>
      </div>

      <!-- Sekcja elementów oferty -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📋</span>
          Elementy oferty
        </h5>
        
        <div class="table-wrapper">
          <table class="offers-table">
            <thead>
              <tr>
                <th>Przedmiot</th>
                <th>Jednostka miary</th>
                <th>Ilość</th>
                <th>Cena netto</th>
                <th>Wartość netto</th>
                <th>Wartość brutto</th>
                <th>Akcje</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in offersElements" :key="item.id">
                <td>
                  <input
                    type="text"
                    class="table-input"
                    v-model="item.name"
                    :key="item.id"
                    placeholder="Nazwa przedmiotu"
                  />
                </td>
                <td>
                  <input
                    class="table-input"
                    type="text"
                    v-model="item.measure"
                    :key="item.id"
                    placeholder="szt./m2/mb"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="table-input"
                    v-model="item.amount"
                    :key="item.id"
                    step="0.01"
                    @change="total()"
                    placeholder="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="table-input"
                    :id="index"
                    v-model="item.price"
                    :key="item.id"
                    step="0.01"
                    @change="total()"
                    placeholder="0.00"
                  />
                </td>
                <td class="calculated-value">
                  <span v-if="item.price">{{ (item.price * item.amount).toFixed(2) }} zł</span>
                  <span v-else class="text-muted">0.00 zł</span>
                </td>
                <td class="calculated-value">
                  <span v-if="item.price">{{ (item.price * item.amount * vat).toFixed(2) }} zł</span>
                  <span v-else class="text-muted">0.00 zł</span>
                </td>
                <td class="text-center">
                  <button class="btn-delete-small" @click="deleteItem(index)" title="Usuń">
                    🗑️
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="summary-row">
                <td><strong>Suma</strong></td>
                <td>
                  <select
                    class="vat-select"
                    v-model="vat"
                    @change="total()"
                  >
                    <option value="0">VAT</option>
                    <option value="1.08">8%</option>
                    <option value="1.23">23%</option>
                  </select>
                </td>
                <td></td>
                <td></td>
                <td class="total-value"><strong>{{ totalPriceNetto.toFixed(2) }} zł</strong></td>
                <td class="total-value"><strong>{{ totalPriceBrutto.toFixed(2) }} zł</strong></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <button class="btn-add-element" @click="addElement()">
          + Dodaj element
        </button>
      </div>

      <!-- Sekcja dodatkowych informacji -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📷</span>
          Zdjęcie i uwagi
        </h5>

        <div class="image-upload-section">
          <label class="image-upload-label" for="customInputFile">
            <svg
              width="1.5em"
              height="1.5em"
              viewBox="0 0 16 16"
              class="bi bi-camera"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M15 12V6a1 1 0 0 0-1-1h-1.172a3 3 0 0 1-2.12-.879l-.83-.828A1 1 0 0 0 9.173 3H6.828a1 1 0 0 0-.707.293l-.828.828A3 3 0 0 1 3.172 5H2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"
              />
              <path
                fill-rule="evenodd"
                d="M8 11a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
              />
              <path d="M3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" />
            </svg>
            <span>Dodaj zdjęcie</span>
          </label>

          <input
            style="display: none"
            id="customInputFile"
            class="custom-file-input"
            type="file"
            accept="image/*"
            @change="uploadImage"
          />

          <img v-if="imageURL" :src="imageURL" alt="Podgląd" class="image-preview" />
        </div>

        <div class="form-group">
          <label class="form-label">Uwagi do oferty</label>
          <textarea
            class="form-textarea"
            rows="3"
            placeholder="Uwagi do oferty"
            v-model="notice"
          ></textarea>
        </div>
      </div>

      <!-- Przycisk generowania -->
      <div class="generate-section">
        <button class="btn-generate" @click="openOfferModal(offersElements)">
          📝 Wygeneruj ofertę PDF
        </button>
      </div>
    </div>

    <offer-modal
      @closeModal="closeModal()"
      :offer="offersElements"
      :netto="totalPriceNetto"
      :brutto="totalPriceBrutto"
      :vat="vat"
      :imageUrl="imageURL"
      :offerHeader="offerHeader"
      :header="this.header"
      :user="userProfile"
      :notice="notice"
      :header2="this.header"
      :subheader="this.subheader"
      :offerNumber="this.offerNumber"
      :duplicatedContractor="duplicatedContractor"
      :number="currentCounterValue"
    ></offer-modal>
  </div>
</template>
<script>
// import func from "vue-editor-bridge";
import { mapState } from "vuex";

import OfferModal from "../components/OfferModal";

// const toBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });

export default {
  data() {
    return {
      //   total: "",
      vat: 0,
      totalPriceNetto: 0,
      totalPriceBrutto: 0,
      offerHeader: "",
      imageURL: "",
      notice: "",
      header: "",
      subheader: "",
      offersElements: [],
      showDuplicateToast: false,
      duplicatedContractor: "",
    };
  },
  components: {
    "offer-modal": OfferModal,
  },
  computed: {
    ...mapState(["userProfile", "others"]),
    defaultOffersElements() {
      return this.$store.state.offersElements;
    },
    offerNumber() {
      if (!this.others || this.others.length === 0) {
        return "Ładowanie...";
      }
      const counterDoc = this.others.find(item => item.id === 'counter');
      if (!counterDoc || typeof counterDoc.value === 'undefined') {
        return "Ładowanie...";
      }
      let data = new Date().toLocaleDateString();
      data = data.replace(/\./g, "/");
      return counterDoc.value + "/" + data;
    },
    currentCounterValue() {
      if (!this.others || this.others.length === 0) {
        return 0;
      }
      const counterDoc = this.others.find(item => item.id === 'counter');
      if (!counterDoc || typeof counterDoc.value === 'undefined') {
        return 0;
      }
      return counterDoc.value;
    },
  },
  methods: {
    openOfferModal(offer) {
      window.scrollTo(0, 0);
      this.$modal.show("offer-modal");
      this.offer = offer;
      // Prevent navigating to narrower view (default vue-cal behavior).
    },
    closeModal() {
      setTimeout(() => {
        // this.events = [];
        // console.log(this.installations);
        //   //   const item1 = this.config.chart.items["1"];
        //   //   item1.label = "label changed dynamically";
        //   //   item1.time.end += 2 * 24 * 60 * 60 * 1000;
        // this.setEvents();
      }, 100);
      this.$modal.hide("offer-modal");
    },
    addElement() {
      this.offersElements.push({ name: "wpisz nazwę" });
    },
    deleteItem(index) {
      this.offersElements.splice(index, 1);
    },

    uploadImage() {
      var img = document.getElementById("customInputFile").files[0];
      this.getBase(img, (response) => {
        this.imageURL = response;
      });
    },

    getBase(img, callback) {
      var reader = new FileReader();
      reader.onload = function (fileLoadedEvent) {
        var srcData = fileLoadedEvent.target.result;
        callback(srcData);
      };
      reader.readAsDataURL(img);
      //   console.log("outer", this.imageURL);
    },

    total() {
      this.totalPriceNetto = 0;
      this.totalPriceBrutto = 0;
      this.offersElements.forEach((item) => {
        if (item.price) {
          this.totalPriceNetto += item.price * item.amount;
          this.totalPriceBrutto += item.price * item.amount * this.vat;
        }
      });
    },
    loadOfferDefaults() {
      // Załaduj globalne domyślne wartości ofert (dla wszystkich użytkowników)
      const offerDefaults = this.others.find(item => item.id === 'offerDefaults');
      
      if (offerDefaults) {
        if (offerDefaults.header && offerDefaults.header.trim() !== '') {
          this.offerHeader = offerDefaults.header;
        } else {
          this.offerHeader = "Szczegółowa kalkulacja cenowa: Klimatyzator z Wi-Fi <span style='color:red'>5 Lat Gwarancji</span>";
        }
        
        if (offerDefaults.title && offerDefaults.title.trim() !== '') {
          this.header = offerDefaults.title;
        } else {
          this.header = "Niniejsza oferta cenowa zawiera szczegółową kalkulację na dostawę,<br />montaż i uruchomienie klimatyzatora.";
        }
        
        if (offerDefaults.details && offerDefaults.details.trim() !== '') {
          this.subheader = offerDefaults.details;
        } else {
          this.subheader = "W ramach przedstawionej oferty gwarantujemy: <br /><br /> ➢ Stały serwis gwarancyjny na wykonane roboty i dostarczone urządzenia <br /> ➢ Serwis konserwatorski po upływie okresu gwarancyjnego <br /> ➢ Serwis sprzątający podczas instalacji urządzeń klimatyzacyjnych  <br />➢ Szkolenie z zakresu obsługi urządzenia";
        }
        
        if (offerDefaults.notes && offerDefaults.notes.trim() !== '') {
          this.notice = offerDefaults.notes;
        } else {
          this.notice = "Oferta ważna 14 dni.";
        }
      } else {
        // Jeśli nie ma zapisanych wartości globalnych, użyj domyślnych
        this.offerHeader = "Szczegółowa kalkulacja cenowa: Klimatyzator z Wi-Fi <span style='color:red'>5 Lat Gwarancji</span>";
        this.header = "Niniejsza oferta cenowa zawiera szczegółową kalkulację na dostawę,<br />montaż i uruchomienie klimatyzatora.";
        this.subheader = "W ramach przedstawionej oferty gwarantujemy: <br /><br /> ➢ Stały serwis gwarancyjny na wykonane roboty i dostarczone urządzenia <br /> ➢ Serwis konserwatorski po upływie okresu gwarancyjnego <br /> ➢ Serwis sprzątający podczas instalacji urządzeń klimatyzacyjnych  <br />➢ Szkolenie z zakresu obsługi urządzenia";
        this.notice = "Oferta ważna 14 dni.";
      }
      
      // Załaduj globalne domyślne produkty (dla wszystkich użytkowników)
      const offerProducts = this.others.find(item => item.id === 'offerProducts');
      
      if (offerProducts && offerProducts.items && offerProducts.items.length > 0) {
        // Stwórz głęboką kopię produktów z Firebase
        this.offersElements = JSON.parse(JSON.stringify(offerProducts.items));
        console.log('Załadowano produkty z Firebase:', this.offersElements);
      } else {
        // Użyj domyślnych produktów ze store
        this.offersElements = JSON.parse(JSON.stringify(this.defaultOffersElements));
        console.log('Użyto domyślnych produktów ze store:', this.offersElements);
      }
    }
  },
  watch: {
    others: {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.loadOfferDefaults();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // Słuchaj na wiadomość o powielanej ofercie
    this.$root.$on('loadDuplicatedOffer', (duplicatedOffer) => {
      // Załaduj dane powielanej oferty do formularza
      this.offerHeader = duplicatedOffer.offerHeader || "";
      this.header = duplicatedOffer.header || "";
      this.subheader = duplicatedOffer.subheader || "";
      this.notice = duplicatedOffer.notice || "";
      this.imageURL = duplicatedOffer.imageUrl || "";
      this.vat = duplicatedOffer.vat || 0;
      
      // Załaduj elementy oferty
      if (duplicatedOffer.offer && duplicatedOffer.offer.length > 0) {
        this.offersElements = JSON.parse(JSON.stringify(duplicatedOffer.offer));
      }
      
      // Przelicz totalne wartości
      this.$nextTick(() => {
        this.total();
      });
      
      // Pokaz toast powiadomienie
      this.duplicatedContractor = duplicatedOffer.contractor;
      this.showDuplicateToast = true;
      setTimeout(() => {
        this.showDuplicateToast = false;
      }, 4000);
    });
  },
  beforeDestroy() {
    // Wyczyść listener
    this.$root.$off('loadDuplicatedOffer');
  },
};
</script>

<style scoped>
.offers-view {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 24px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.header-left,
.header-right {
  flex: 1;
}

.header-center {
  flex: 2;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.page-title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.offer-number-badge {
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(135deg, #e6e9ff 0%, #f3e7ff 100%);
  color: #667eea;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 700;
  border-left: 3px solid #667eea;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* FORM CONTAINER */
.form-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* SEKCJE FORMULARZA */
.form-section {
  background: white;
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f8f9fa;
}

.section-icon {
  font-size: 24px;
}

/* POLA FORMULARZA */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 14px;
  color: #2c3e50;
  transition: all 0.3s ease;
  font-family: inherit;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea {
  resize: vertical;
}

/* TABELA */
.table-wrapper {
  overflow-x: auto;
  margin-bottom: 20px;
}

.offers-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.offers-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.offers-table th {
  padding: 14px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #dee2e6;
}

.offers-table tbody tr {
  border-bottom: 1px solid #e9ecef;
  transition: background 0.2s ease;
}

.offers-table tbody tr:hover {
  background: #f8f9fa;
}

.offers-table td {
  padding: 12px;
  font-size: 14px;
  color: #2c3e50;
  vertical-align: middle;
}

.offers-table tfoot {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  font-weight: 700;
}

.offers-table tfoot td {
  padding: 16px 12px;
  border-top: 2px solid #dee2e6;
}

.table-input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.2s ease;
}

.table-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.calculated-value {
  font-weight: 600;
  color: #28a745;
}

.text-muted {
  color: #adb5bd;
  font-weight: 400;
}

.text-center {
  text-align: center;
}

.total-value {
  font-size: 15px;
  color: #667eea;
}

.vat-select {
  padding: 8px 10px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.vat-select:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

/* PRZYCISKI */
.btn-delete-small {
  background: #dc3545;
  color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-delete-small:hover {
  background: #c82333;
  transform: scale(1.1);
}

.btn-add-element {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.btn-add-element:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

/* SEKCJA OBRAZU */
.image-upload-section {
  margin-bottom: 20px;
}

.image-upload-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
  font-weight: 600;
  margin-bottom: 15px;
}

.image-upload-label:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.image-preview {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  margin-top: 15px;
}

/* SEKCJA GENEROWANIA */
.generate-section {
  text-align: center;
  padding: 30px 0;
}

.btn-generate {
  padding: 18px 48px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.4);
}

.btn-generate:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.5);
}

.btn-generate:active {
  transform: translateY(-1px);
}

/* Toast powiadomienia */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.4);
  z-index: 10000;
  font-weight: 600;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .offers-view {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    padding: 16px;
  }

  .header-left,
  .header-center,
  .header-right {
    width: 100%;
    text-align: center;
  }

  .form-section {
    padding: 20px;
  }

  .table-wrapper {
    overflow-x: auto;
  }

  .offers-table {
    min-width: 800px;
  }

  .btn-generate {
    width: 100%;
    padding: 16px;
  }
}
</style>
